var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5149\u4F0F\u7AD9\u70B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0206098%",
    y1: "-32.9793902%",
    x2: "17.0206098%",
    y2: "119.959176%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7E9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-94.000000, -516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5149\\u4F0F\\u7AD9\\u70B9",
    transform: "translate(94.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32.561052,
    height: 32.561052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4226675,18.2976895 L29.692436,6.21102066 C29.1943783,4.52880166 27.688686,3.34422532 25.9364996,3.2561052 L6.91270497,3.2561052 C5.15973052,3.35406635 3.63076694,4.47986454 3.01679418,6.12472116 L3.01679418,6.19963701 C3.01679418,6.28752642 0.838447088,15.0660051 0.200263189,18.2960678 C-0.185330412,19.5610298 -0.00736153362,20.9307876 0.688678968,22.0552158 C1.38475055,22.9775032 2.43123578,23.5708798 3.58006223,23.6946839 L29.003757,23.6946839 C30.1743397,23.5789503 31.2316139,22.9451855 31.8854101,21.9673264 C32.5306438,20.8269333 32.7224735,19.4852836 32.4226675,18.2097683 L32.4226675,18.2976895 L32.4226675,18.2976895 Z M3.61752015,21.8794052 C2.99929402,21.7899696 2.43671937,21.4729743 2.03996263,20.9904949 C1.65722762,20.2963386 1.58453171,19.4730903 1.83969944,18.7226049 C2.50395762,15.704189 4.47065787,7.60300564 4.68227291,6.72385723 C5.01417021,5.75547228 5.90178297,5.08637923 6.92412042,5.03392592 L25.9364996,5.03392592 C26.8970506,5.09904802 27.7143203,5.75351245 27.9894676,6.67501565 L30.7197308,18.7112212 C30.8922981,19.481271 30.7913715,20.2871571 30.4315465,20.9904949 C30.0611822,21.5223242 29.4639924,21.8510196 28.816531,21.8794052 L3.61752015,21.8794052 L3.61752015,21.8794052 Z M17.5325048,27.0517156 L22.9669253,28.1669316 L22.9669253,29.4189105 L9.77969924,29.4189105 L9.77969924,28.2288104 L15.0269255,27.0517156 L15.0269255,24.6975579 L17.5325048,24.6975579 L17.5325048,27.0517156 Z M5.83491508,6.60013159 L7.25132084,5.68514696 L14.6263991,5.68514696 L15.6911519,6.63755773 L15.6911519,10.8086476 L14.551515,11.9482844 L5.84795222,11.9482844 L4.90857858,10.6946839 L5.84795222,6.61313694 L5.83491508,6.6000998 L5.83491508,6.60013159 Z M4.18406338,14.1135943 L5.83653677,12.6743895 L14.4407948,12.6743895 L15.6943953,14.1021789 L15.6943953,19.336368 L14.3658789,20.5899685 L4.18250528,20.5899685 L3.09171004,19.1621791 L4.18250528,14.0761364 L4.18250528,14.1135943 L4.18406338,14.1135943 Z M26.9116777,6.60013159 L27.6508199,10.6946839 L26.7114145,11.9482844 L17.944383,11.9482844 L16.8047462,10.8574891 L16.8047462,6.60013159 L17.9183405,5.68514696 L25.5083408,5.68514696 L26.9117095,6.60013159 L26.9116777,6.60013159 Z M28.3638879,14.1135943 L29.4546831,19.199637 L28.3638879,20.6274264 L18.1821041,20.6274264 L16.8552413,19.3738259 L16.8552413,14.1021789 L18.1071883,12.6743895 L26.7114463,12.6743895 L28.3639197,14.1021789 L28.3639197,14.1135943 L28.3638879,14.1135943 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPv);
export default __webpack_public_path__ + "static/media/pv.52b1527d727343c1444c80a429907ddd.svg";
export { ForwardRef as ReactComponent };